import React, { Component } from 'react';
import Parser from 'html-react-parser'
import { ArrowIcon, DocumentIcon } from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';

class First extends Component {
  static defaultProps = {

  }

  constructor(props) {
    super(props);
    this.state = {
      showCallForm: false,
    };
  }

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {

    const data = this.props?.data || {}
    const first = data.first || {}
    const links = data?.links || []
    const { showCallForm } = this.state

    return (
      <>
        <div className='mt-[50px] xl:mt-[40px] w-full max-w-full'>
          <div className='container'>
            <div className='flex flex-col xl:flex-row items-start justify-between gap-[12px] xl:gap-[20px] w-full'>

              <div className='text-title text-ptblack leading-none uppercase tracking-tight xl:hidden'>
                {Parser(first?.btitle || '')}
              </div>
              <div className='text-ptgray text-base leading-none xl:hidden'>
                {Parser(first?.btext || '')}
              </div>

              <div className='w-full xl:w-auto'>
                <img src={first?.image} width={797} height={329} className='h-auto max-w-full flex-none mx-auto mt-[8px] xl:mt-0 rounded-[12px]' />
                <div className='text-title text-ptblack mt-[40px] leading-none uppercase tracking-tight hidden xl:block'>
                  {Parser(first?.btitle || '')}
                </div>
              </div>

              <div className='w-full xl:hidden'>
                <div className='flex flex-col items-center gap-[8px] w-full'>
                  <div onClick={() => this.openCallForm()} className='w-full cursor-pointer bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                    <DocumentIcon />
                    <div className='text-base'>Запросить КП</div>
                  </div>
                  <a href={links?.catalog} className='w-full cursor-pointer bg-[#F6F7F8] duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
                    <div className='text-base'>Смотреть продукцию</div>
                    <ArrowIcon />
                  </a>
                </div>
                <div className='text-ptgray text-base leading-none w-full mt-[20px]'>Согласуем цену и условия под объём, <br />тару и регион поставки.</div>
                <div className='tracking-tight text-end mt-[10px] mb-[30px]'>
                  <div className='uppercase leading-none text-[#001553] text-[24px]'>основано</div>
                  <div className='uppercase leading-none text-[#BC0005] text-[50px]'>в 1998 году</div>
                </div>
              </div>

              <div className='flex-1 flex flex-col gap-[20px] w-full xl:w-auto items-center'>
                <a href={links?.catalog} style={{ backgroundImage: `url('${first?.cardbg}')` }} className='group flex flex-col justify-between bg-no-repeat bg-center bg-cover rounded-[14px] bg-[#BC0005] w-full min-h-[120px] p-[20px]'>
                  <div className='text-white font-normal text-cardTitle uppercase'>Продукция</div>
                  <div className='w-full flex justify-end'>
                    {/* Белый контейнер с меняющейся шириной - всегда виден */}
                    <div className='cursor-pointer bg-white ease-in-out hover:bg-[#DBE7F3] h-[38px] flex items-center justify-end rounded-[14px] transition-all duration-300 overflow-hidden w-[38px] group-hover:w-[162px]'>
                      
                      {/* Внутренний блок с фиксированной шириной */}
                      <div className='flex items-center gap-[12px] px-[12px] w-[162px]'>
                        
                        {/* Текст появляется при наведении */}
                        <div className='text-base whitespace-nowrap transition-all duration-300 opacity-0 group-hover:opacity-100'>
                          Перейти в каталог
                        </div>
                        
                        {/* Стрелка всегда видна */}
                        <ArrowIcon width={16} height={16} className="shrink-0" />
                      </div>
                    </div>
                  </div>
                </a>
                <div className='rounded-[14px] bg-[#F6F7F8] w-full min-h-[189px] p-[20px]'>
                  <div className='text-ptblack font-normal text-cardTitle uppercase leading-none'>
                    {Parser(first?.cardtitle || '')}
                  </div>
                  <div className='mt-[12px] text-pthalf text-base leading-none'>
                    {Parser(first?.cardtext || '')}
                  </div>
                  <a 
                    href={links?.materiali} 
                    className='w-full flex items-center justify-center gap-[8px] bg-white rounded-[14px] h-[48px] mt-[25px] transition-colors duration-300 hover:bg-[#141414] group text-[#141414] hover:text-white'
                  >
                    <div className='text-base transition-colors duration-300 group-hover:text-white'>Все материалы</div>
                    <ArrowIcon width={16} height={16} stroke="currentColor" />
                  </a>
                </div>
                <div className='mt-[19px] text-ptgray text-base leading-none hidden xl:block'>
                  {Parser(first?.btext || '')}
                </div>
              </div>
            </div>

            <div className='w-full hidden xl:flex items-end justify-between'>
              <div className='flex items-center gap-[40px]'>
                <div className='flex items-center gap-[8px]'>
                  <div onClick={() => this.openCallForm()} className='cursor-pointer bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                    <DocumentIcon />
                    <div className='text-base'>Запросить КП</div>
                  </div>
                  <a href={links?.catalog} className='cursor-pointer bg-[#F6F7F8] duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
                    <div className='text-base'>Смотреть продукцию</div>
                    <ArrowIcon />
                  </a>
                </div>
                <div className='text-ptgray text-base leading-none max-w-[270px]'>Согласуем цену и условия под объём, тару и регион поставки.</div>
              </div>
              <div className='tracking-tight text-end'>
                <div className='uppercase leading-none text-[#001553] text-[27.54px]'>основано</div>
                <div className='uppercase leading-none text-[#BC0005] text-[73.45px]'>в 1998 году</div>
              </div>
            </div>

          </div>
        </div>

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Запросить коммерческое предложение"
          formText="Укажите контактные данные и количество — подготовим КП по выбранному товару. Если нужна доставка, добавьте адрес: рассчитаем условия и сроки под ваш регион."
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    )
  }
}

export default First;
